<template>
  <!-- -->
  <yq-table :data="dataList" height="100%" stripe border v-if="level === 1" page-name="workerAttendance1">
    <yq-table-column label="项目" prop="projectName"/>
    <yq-table-column label="工地" prop="siteName"/>
    <yq-table-column label="施工班组" prop="classmateName"/>
    <yq-table-column label="标段" prop="lotName"/>
    <yq-table-column label="考勤日期" prop="attendanceDate">
      <template v-slot="{row}">{{ row.attendanceDate?row.attendanceDate.split(" ")[0] : '' }}</template>
    </yq-table-column>
    <yq-table-column label="人员总数" prop="resultTotal">
      <template v-slot="{row}">{{ row.resultTotal }}</template>
    </yq-table-column>
    <yq-table-column label="正常" prop="resultNormal">
      <template v-slot="{row}">{{ row.resultNormal }}</template>
    </yq-table-column>
    <yq-table-column label="迟到" prop="resultLate">
      <template v-slot="{row}">
        <span :class="row.resultLate > 0? 'error-status': ''">{{ row.resultLate }}</span>
      </template>
    </yq-table-column>
    <yq-table-column label="早退" prop="resultLeaveEarly">
      <template v-slot="{row}">
        <span :class="row.resultLeaveEarly > 0? 'error-status': ''">{{ row.resultLeaveEarly }}</span>
      </template>
    </yq-table-column>
    <yq-table-column label="缺卡" prop="resultLack">
      <template v-slot="{row}">
        <span :class="row.resultLack > 0? 'error-status': ''">{{ row.resultLack }}</span>
      </template>
    </yq-table-column>
    <yq-table-column label="操作" prop="option" align="center">
      <template v-slot="{row}">
        <table-button-group>
          <table-button hasPerm="laborers:attendance:query" el-type="primary" @click="toDetail(row)">查看</table-button>
        </table-button-group>
      </template>
    </yq-table-column>
  </yq-table>
  <yq-table :data="dataList" height="100%" stripe border v-else-if="level === 2" page-name="workerAttendance2">
    <yq-table-column label="劳务人员" prop="workersName"/>
    <yq-table-column label="上班考勤时间" prop="attendanceResultMin" width="200rem">
      <template v-slot="{}">{{attendanceToday.inTime}}</template>
    </yq-table-column>
    <yq-table-column label="下班考勤时间" prop="attendanceResultMax" width="200rem">
      <template v-slot="{}">{{attendanceToday.outTime}}</template>
    </yq-table-column>
    <yq-table-column label="上班打卡" prop="attendanceResultIn">
      <template v-slot="{row}">
        <span v-if="row.attendanceResultIn === 0">未打卡</span>
        <span v-else-if="row.attendanceResultIn === 1">正常</span>
        <span class="error-status" v-else-if="row.attendanceResultIn === 11">迟到</span>
        <span class="error-status" v-else-if="row.attendanceResultIn === 12">缺卡</span>
        <span class="error-status" v-else-if="row.attendanceResultIn === 19">请假</span>
        <span v-else-if="row.attendanceResultIn === 0"></span>
      </template>
    </yq-table-column>
    <yq-table-column label="下班打卡" prop="attendanceResultOut">
      <template v-slot="{row}">
        <span v-if="row.attendanceResultOut === 0">未打卡</span>
        <span v-else-if="row.attendanceResultOut === 1">正常</span>
        <span class="error-status" v-else-if="row.attendanceResultOut === 21">早退</span>
        <span class="error-status" v-else-if="row.attendanceResultOut === 22">缺卡</span>
        <span class="error-status" v-else-if="row.attendanceResultOut === 29">请假</span>
        <span v-else-if="row.attendanceResultOut === 0"></span>
      </template>
    </yq-table-column>
    <yq-table-column label="打卡结果" prop="resultNormal">
      <template v-slot="{row}">
        <span v-if="row.attendanceResult === 1">正常</span>
        <span class="error-status" v-else-if="row.attendanceResult === 2">异常</span>
      </template>
    </yq-table-column>
    <yq-table-column label="操作" prop="option" align="center">
      <template v-slot="{row}">
        <table-button-group>
          <table-button hasPerm="laborers:attendance:query" el-type="primary" @click="toDetail(row)">查看</table-button>
        </table-button-group>
      </template>
    </yq-table-column>
  </yq-table>
  <yq-table :data="dataList" height="100%" stripe border v-else-if="level === 3" empty-text="该人员未进行打卡" page-name="workerAttendance3">
    <yq-table-column label="项目" prop="projectName">
      <template v-slot="{}">{{currentData.projectName}}</template>
    </yq-table-column>
    <yq-table-column label="工地" prop="siteName">
      <template v-slot="{}">{{currentData.siteName}}</template>
    </yq-table-column>
    <yq-table-column label="施工班组" prop="classmateName">
      <template v-slot="{}">{{currentData.classmateName}}</template>
    </yq-table-column>
    <yq-table-column label="劳务人员" prop="type">
      <template v-slot="{}">{{currentData.workersName}}</template>
    </yq-table-column>
    <yq-table-column label="实际打卡时间" prop="realTime"/>
    <yq-table-column label="考勤方式" prop="attendanceType">
      <template v-slot="{row}">
        <el-tag v-if="row.attendanceType === 1" type="success">设备打卡</el-tag>
        <el-tag v-if="row.attendanceType === 2" type="danger">补卡</el-tag>
      </template>
    </yq-table-column>
    <yq-table-column label="考勤类型" prop="workType">
      <template v-slot="{row}">
        <el-tag v-if="row.workType === 1" type="primary">上班</el-tag>
        <el-tag v-if="row.workType === 2" type="primary">下班</el-tag>
      </template>
    </yq-table-column>
    <yq-table-column label="考勤结果" prop="attendanceResult">
      <template v-slot="{row}">
        <el-tag v-if="row.attendanceResult === 1" type="success">正常</el-tag>
        <el-tag v-if="row.attendanceResult === 11" type="danger">迟到</el-tag>
        <el-tag v-if="row.attendanceResult === 21" type="danger">早退</el-tag>
        <el-tag v-if="row.attendanceResult === 99" type="warning">无效打卡</el-tag>
      </template>
    </yq-table-column>

  </yq-table>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import TableButton from "@/components/h5/button/TableButton.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";

export default {
  props: {
    currentData: {default: () => {}},
    dataList: {default: () => []},
    level: {default: 0},
    attendanceToday: {default: () => {}},
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "LAW",
  components: {
    TableButtonGroup, YqTableColumn, TableButton
  },
  data() {
    return {

    };
  },
  created() {
  },
  methods: {
    toDetail(data) {
      this.$emit("toDetail", data);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "attandenceResult";
</style>